import { useCallback } from 'react';
import type { UserWidgetPreference, LayoutUpdatePayload, DashboardPeriod, DashboardFetcher } from '../types';
import { saveUserLayout } from '../api/dashboardLayout';
import { useOptimisticLayout } from '../../components/DashboardEngine/hooks/useOptimisticLayout';

interface UseDashboardLayoutProps {
  userId: string;
  initialLayout: UserWidgetPreference[];
  period: DashboardPeriod;
  fetcher: DashboardFetcher;
}

export const useDashboardLayout = ({ userId, initialLayout, period, fetcher }: UseDashboardLayoutProps) => {
  const saveLayout = useCallback(async (currentLayout: UserWidgetPreference[]) => {
    const payload: LayoutUpdatePayload = {
      userId,
      period,
      layout: currentLayout
    };
    await saveUserLayout(payload, fetcher);
  }, [userId, period, fetcher]);

  return useOptimisticLayout<UserWidgetPreference>({
    initialLayout,
    saveLayout,
    debounceMs: 800,
    storageKey: `dashboard_layout_${userId}`
  });
};
